<template>
  <div>
    <TopBar />
    <el-container>
      <el-aside width="200px">
        <SideBar />
      </el-aside>
      <el-main>
        <!-- 顶部标题 -->
        <div class="page-header">
          <h1>教师列表</h1>
        </div>

        <!-- 分类导航栏和搜索框 -->
        <el-row :gutter="20" class="navbar-container">
          <!-- 导航栏 -->
          <el-col :span="6">
            <div class="navbar">
              <span
                class="navbar-item"
                v-for="(category, index) in categories"
                :key="index"
                :class="{ active: selectedCategory === category }"
                @click="selectCategory(category)"
              >
                {{ category }}
              </span>
            </div>
          </el-col>

          <!-- 搜索框 -->
          <el-col :span="18" class="search-container">
            <el-input
              v-model="searchQuery"
              class="search-input"
              placeholder="搜索教师姓名或职称"
              @input="searchTeachers"
            />
          </el-col>
        </el-row>

        <!-- 教师信息表格 -->
        <el-row :gutter="20">
          <el-col :span="8" v-for="(teacher, index) in filteredTeachers" :key="index">
            <div class="teacher-card">
              <div class="teacher-image">
                <img :src="teacher.image" alt="Teacher Avatar" />
              </div>
              <div class="teacher-details">
                <p class="teacher-name">{{ teacher.name }}</p>
                <p class="teacher-title">{{ teacher.title }}</p>
                <p class="teacher-department">{{ teacher.department }}</p>
                <p class="teacher-email">{{ teacher.email }}</p>
                <p class="teacher-research">{{ teacher.research }}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import SideBar from '../components/SideBar.vue';
import TopBar from '../components/TopBar.vue';

export default {
  name: 'TeacherList',
  components: { SideBar, TopBar },
  data() {
    return {
      searchQuery: '',
      selectedCategory: '全部',
      categories: ['全部', '计算机科学与技术系', '软件工程系', '信息与通信工程系'],
      teachers: [
        {
          image: '/images/teacher.jpg',
          name: '李老师',
          title: '副教授',
          department: '计算机科学与技术系',
          email: 'li.teacher@university.com',
          research: '人工智能，机器学习'
        },
        {
          image: '/images/teacher.jpg',
          name: '王老师',
          title: '教授',
          department: '软件工程系',
          email: 'wang.teacher@university.com',
          research: '软件工程，系统架构'
        },
        {
          image: '/images/teacher.jpg',
          name: '张老师',
          title: '讲师',
          department: '信息与通信工程系',
          email: 'zhang.teacher@university.com',
          research: '无线通信，信号处理'
        },
        {
          image: '/images/teacher.jpg',
          name: '赵老师',
          title: '博士后',
          department: '计算机科学与技术系',
          email: 'zhao.teacher@university.com',
          research: '大数据，云计算'
        },
        {
          image: '/images/teacher.jpg',
          name: '钱老师',
          title: '副教授',
          department: '软件工程系',
          email: 'qian.teacher@university.com',
          research: '数据库系统，数据挖掘'
        },
        {
          image: '/images/teacher.jpg',
          name: '孙老师',
          title: '教授',
          department: '信息与通信工程系',
          email: 'sun.teacher@university.com',
          research: '网络安全，物联网'
        }
      ]
    };
  },
  computed: {
    filteredTeachers() {
      return this.teachers
        .filter(teacher => {
          const searchTerm = this.searchQuery.toLowerCase();
          return (
            teacher.name.toLowerCase().includes(searchTerm) ||
            teacher.title.toLowerCase().includes(searchTerm)
          );
        })
        .filter(teacher => {
          return this.selectedCategory === '全部' || teacher.department === this.selectedCategory;
        });
    }
  },
  methods: {
    searchTeachers() {
      // 实际搜索逻辑处理可以根据具体需求进行扩展
    },
    selectCategory(category) {
      this.selectedCategory = category;
    }
  }
};
</script>

<style scoped>
.page-header {
  margin-top: 30px;
  text-align: center;
}

h1 {
  font-size: 28px;
  font-weight: bold;
}

.navbar-container {
  margin-top: 20px;
}

.navbar {
  display: flex; /* 横向排列 */
  flex-direction: row; /* 横向排列 */
  justify-content: flex-start; /* 左对齐 */
  gap: 20px; /* 菜单项之间的间隔 */
}

.navbar-item {
  font-size: 16px; /* 文字大小 */
  color: #555; /* 文字颜色 */
  padding: 5px 15px; /* 内边距，增加点击区域 */
  cursor: pointer; /* 鼠标样式 */
  white-space: nowrap; /* 防止文字换行 */
}

.navbar-item:hover {
  color: #007bff; /* 鼠标悬停时的文字颜色 */
}

.navbar-item.active {
  color: #007bff; /* 激活状态下的文字颜色 */
  font-weight: bold; /* 激活状态下加粗 */
}

.search-container {
  display: flex;
  justify-content: flex-end;
}

.search-input {
  padding: 8px 16px;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #ccc;
  width: 250px;
}

.teacher-card {
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  display: flex;
  padding: 20px;
}

.teacher-image {
  width: 100px;
  height: 150px;
  margin-right: 20px;
}

.teacher-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.teacher-details {
  flex-grow: 1;
}

.teacher-name {
  font-size: 20px;
  font-weight: bold;
  color: #007bff;
}

.teacher-title {
  font-size: 18px;
  color: #007bff;
}

.teacher-department,
.teacher-email,
.teacher-research {
  font-size: 14px;
  color: #888;
}

.teacher-research {
  margin-top: 10px;
}

.el-dialog {
  width: 400px;
}
</style>
